import React from 'react';
import { DetailsList, IDetailsListProps, IDetailsListStyles } from '@fluentui/react';

const scrollableGridStyles: Partial<IDetailsListStyles> = {
	root: {
		overflowX: 'scroll',
		selectors: {
			'& [role=grid]': {
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'start',
			},
		},
	},
	headerWrapper: {
		flex: '0 0 auto',
	},
	contentWrapper: {
		flex: '1 1 auto',
		overflow: 'hidden',
	},
};

export class ScrollableDetailsList extends React.Component<IDetailsListProps> {

	private topScrollRef = React.createRef<HTMLDivElement>();
	private phantomRef = React.createRef<HTMLDivElement>();
	private listWrapperRef = React.createRef<HTMLDivElement>();
	private syncing = false;
	private resizeObserver?: ResizeObserver;

	componentDidMount() { this.initScrollSync(); }
	componentDidUpdate() { this.initScrollSync(); }
	componentWillUnmount() { this.resizeObserver?.disconnect(); }

	private initScrollSync() {
		const listEl = this.listWrapperRef.current?.firstElementChild as HTMLElement | null;
		const topEl = this.topScrollRef.current;
		if (!listEl || !topEl) return;

		listEl.onscroll = () => {
			if (this.syncing) return;
			this.syncing = true;
			topEl.scrollLeft = listEl.scrollLeft;
			this.syncing = false;
		};
		topEl.onscroll = () => {
			if (this.syncing) return;
			this.syncing = true;
			listEl.scrollLeft = topEl.scrollLeft;
			this.syncing = false;
		};

		this.resizeObserver?.disconnect();
		const gridEl = listEl.querySelector('[role="grid"]>div.ms-DetailsList-headerWrapper') as HTMLElement | null;
		if (gridEl) {
			const updateWidth = () => {
				if (this.phantomRef.current)
					this.phantomRef.current.style.width = gridEl.offsetWidth + 'px';
			};
			this.resizeObserver = new ResizeObserver(updateWidth);
			this.resizeObserver.observe(gridEl);
			updateWidth();
		}
	}

	render() {
		const { styles, ...rest } = this.props;

		const mergedStyles: Partial<IDetailsListStyles> = {
			...scrollableGridStyles,
			...(typeof styles === 'object' && styles !== null ? styles as Partial<IDetailsListStyles> : {})
		};

		return (
			<>
				{/* commented since it's not working
				<div ref={this.topScrollRef} style={{ overflowX: 'scroll', overflowY: 'hidden', height: 12 }}>
					<div ref={this.phantomRef} style={{ height: 1 }} />
				</div>
				 */}
				<div ref={this.listWrapperRef}>
					<DetailsList styles={mergedStyles} {...rest} />
				</div>
			</>
		);
	}
}

export default ScrollableDetailsList;
